import React, { FC, useState, type PropsWithChildren } from "react";
import AccordionSection from "./AccordionSection";
import { Switch } from "../../../../../components";
import type { ProfileLinkConfig } from "../../../../../client";

const SettingRow: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="flex items-center justify-between gap-2">{children}</div>
  );
};

const SettingText: FC<PropsWithChildren> = ({ children }) => {
  return <p className="text-gray-9 text-sm font-medium grow">{children}</p>;
};

interface HighlightedProjectsLinkSettingsProps {
  disabled?: boolean;
  linkConfig?: ProfileLinkConfig;
  onUpdate: (payload: Partial<ProfileLinkConfig>) => void;
}

const HighlightedProjectsLinkSettings: FC<
  HighlightedProjectsLinkSettingsProps
> = ({ disabled, linkConfig, onUpdate }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <AccordionSection
      title="Highlighted projects"
      subtitle={(() => {
        const activeSettings: string[] = [];
        if (linkConfig?.highlightedProjectsConfig?.showSkills ?? true) {
          activeSettings.push("Skills");

          if (linkConfig?.highlightedProjectsConfig?.showIcons ?? true) {
            activeSettings.push("Icons");
          } else {
            activeSettings.push("No icons");
          }
        } else {
          activeSettings.push("No skills");
        }

        if (activeSettings.length === 0) {
          return "Hide skills";
        }
        return activeSettings.join(", ");
      })()}
      expanded={isExpanded}
      onToggle={() => setIsExpanded(!isExpanded)}
    >
      <SettingRow>
        <Switch
          checked={linkConfig?.highlightedProjectsConfig?.showSkills ?? true}
          disabled={disabled}
          onCheckedChange={(checked) => {
            if (typeof checked !== "boolean") return;

            onUpdate({
              highlightedProjectsConfig: {
                showSkills: checked,
                showIcons:
                  linkConfig?.highlightedProjectsConfig?.showIcons ?? true,
              },
            });
          }}
        />
        <SettingText>Skills</SettingText>
      </SettingRow>
      <SettingRow>
        <Switch
          checked={linkConfig?.highlightedProjectsConfig?.showIcons ?? true}
          disabled={!linkConfig?.highlightedProjectsConfig?.showSkills}
          onCheckedChange={(checked) => {
            if (typeof checked !== "boolean") return;

            onUpdate({
              highlightedProjectsConfig: {
                showSkills:
                  linkConfig?.highlightedProjectsConfig?.showSkills ?? true,
                showIcons: checked,
              },
            });
          }}
        />
        <SettingText>Icons</SettingText>
      </SettingRow>
    </AccordionSection>
  );
};

export default HighlightedProjectsLinkSettings;
